(function ($) {
  var elementorHookRegistered = false;
  var arrowIcon = '<svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="44" cy="44" r="44" fill="#FFFFFF"/><path d="M25 43.6667H62.3333M62.3333 43.6667L43.6667 25M62.3333 43.6667L43.6667 62.3333" stroke="black" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function shouldUseSlider($slider) {
    if ($slider.attr('data-info-cards-force-slider') === 'true') {
      return true;
    }

    return $(window).width() < 768;
  }

  function initSlick($slider) {
    if (!$slider.length || !$.fn.slick || $slider.hasClass('slick-initialized')) {
      return;
    }

    $slider.slick({
      autoplay: false,
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Precedent">' + arrowIcon + '</button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Suivant">' + arrowIcon + '</button>',
      responsive: [
        {
          breakpoint: 1366,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  function destroySlick($slider) {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }

  function handleSlider($slider) {
    if (shouldUseSlider($slider)) {
      initSlick($slider);
    } else {
      destroySlick($slider);
    }
  }

  function initInfoCards($scope) {
    $scope.find('[data-info-cards-slider]').each(function () {
      var $slider = $(this);

      handleSlider($slider);

      if ($slider.data('info-cards-resize-bound')) {
        return;
      }

      $slider.data('info-cards-resize-bound', true);
      $(window).on('resize.infoCards', function () {
        handleSlider($slider);
      });
    });

  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;
    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/info-cards.default',
      initInfoCards
    );
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();

    $('.elementor-widget-info-cards').each(function () {
      initInfoCards($(this));
    });
  });
})(jQuery);
